import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var ThreadAvatar = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "post-avatar-col", children: _jsx("div", { className: "post-avatar", children: initials }) }) }));
};
